import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
@Injectable({
  providedIn: "root",
})


export class DataService {
  public downloadStatus: boolean = false;
  public workbookCreated: boolean = false;
  public projectList: any;
  public projectID: any;
  public userRole: string;
  public AutoExtractStatus: any;
  public instaceRes = new BehaviorSubject<any>(null);
  public authProjectID = new BehaviorSubject<any>(null);
  public token = new BehaviorSubject<any>(null);
  public assetFolderId = new BehaviorSubject<any>(null);
  public keyVaultAuthData: any;
  public count = 0;
  public uiPathAuthData: any;
  public tMenuDisabled: boolean = true;
  public ordstAuthData: any;
  public loggedUserId: any;
  public UI_ORDS: string;
  public setId = false;
  public apiCallInProgress: boolean;
  public configTemplatePath: any;
  public isTrainStopUrl: boolean = false;
  public sftpPath: string;
  public sftpHost: string;
  public sftpPort: any;
  public sftpCredentials: string;
  public LegacyExtract_Applicable = new BehaviorSubject<any>(false);
  public windowFileSharePath: any;
  public uiPathCreds = { username: null, passkey: null };
  public authToken: string;
  constructor(
    private _http: HttpClient
  ) { }

  getisTrainStopUrl() {
    return this.isTrainStopUrl;
  }
  setisTrainStopUrl(val) {
    this.isTrainStopUrl = val;
  }

  // getToken(){
  //   return this.authToken;
  // }

  // updateToken(val){
  //   this.token.next(val);
  // }
}
